import React							from 'react';

import {ChildrenElement}				from '../../typescript-declaration/global';

import './Input.css';


type Props = {
	children: ChildrenElement,
	flexDirection?: 'column' | 'column-reverse' | 'row' | 'row-reverse',
	style?: React.CSSProperties,
	sticky?: boolean
  }

function	MultiInputContainer(props: Props) {
	return (
		<div
			style={props.style}
			className={`multiInputContainer flex-${props.flexDirection} back ${props.sticky && 'sticky'}`}
		>
			{props.children}
		</div>
	);
}

export default MultiInputContainer;
